"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/chooseSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ChooseSectionOfferInfosItem = {
    key: Key | null | undefined;
    /** Detected variants: "isax isax-messages-3" | "isax isax-call-calling" */
    className: string;
    /** Detected variants: "Email Inquiries" | "For Booking Call" */
    p0Text: ReactNode;
    /** Detected variants: "info@example.com" | "+1 24565 89856" */
    p1Text: ReactNode;
    /** Detected variants: "offer-info" */
    divClassName?: string;
    /** Detected variants: "offer-icon" */
    div0ClassName?: string;
    /** Detected variants: "title" */
    p0ClassName?: string;
    /** Detected variants: "fw-semibold mb-0" */
    p1ClassName?: string;
};

type ChooseSection6sItem = {
    key: Key | null | undefined;
    /** Detected variants: "offer-item rotate-1 flex-fill" | "offer-item rotate-n1 flex-fill" */
    className: string;
    /** Detected variants: "/Templates/Doccure/img/icons/offer-01.svg" | "/Templates/Doccure/img/icons/offer-02.svg" | "/Templates/Doccure/img/icons/offer-03.svg" | "/Templates/Doccure/img/icons/offer-04.svg" */
    src: string;
    /** Detected variants: "Personalized Skin Care Solutions" | "Advanced Technology & Treatments" | "Comprehensive Skin Care Services" | "Safe & Comfortable Environment" */
    h30Text: ReactNode;
    /** Detected variants: "Every skin is different. We create customized treatment plans based on your unique needs." | "We use modern equipment and the latest dermatology techniques for safe and reliable results." | "From medical dermatology to cosmetic treatments, we offer complete skin care under one roof." | "We ensure hygienic facilities, patient comfort, and a relaxing consultation experience." */
    p0Text: ReactNode;
    /** Detected variants: "col-md-6 d-flex" */
    divClassName?: string;
    /** Detected variants: "offer-icon" */
    div0ClassName?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "custom-title mb-2" */
    h30ClassName?: string;
    /** Detected variants: "mb-0" */
    p0ClassName?: string;
};
export type HomeFourteenChooseSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseSection6sItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0Div0ClassName?: string;
    /** Default: "Ready Discover More? Contact Us Today!" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "bg" */
    sectionDiv0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/offer-bg.png" */
    sectionDiv0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div1ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div1Div0Div0DivDataWowDuration?: string;
    /** Default: "Why" */
    sectionDiv0Div1Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Choose" */
    sectionDiv0Div1Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "Our Clinic" */
    sectionDiv0Div1Div0Div0H20Span1SpanText?: ReactNode;
    sectionDiv0Div1Div1Div0ClassName?: string;
    chooseSectionOfferInfos: ChooseSectionOfferInfosItem[];
    chooseSection6s: ChooseSection6sItem[];
    chooseSectionOfferInfosItemWrapper?: (item: ChooseSectionOfferInfosItem, content: ReactNode) => ReactNode;
    chooseSectionOfferInfosRenderer?: (defaultNode: ReactNode) => ReactNode;
    chooseSection6sItemWrapper?: (item: ChooseSection6sItem, content: ReactNode) => ReactNode;
    chooseSection6sRenderer?: (defaultNode: ReactNode) => ReactNode;
    chooseSection6sImageVisible?: boolean;
    chooseSection6sImageRenderer?: (item: ChooseSection6sItem, defaultNode: ReactNode) => ReactNode;
    chooseSection6sH3Visible?: boolean;
    chooseSection6sH3Renderer?: (item: ChooseSection6sItem, defaultNode: ReactNode) => ReactNode;
    chooseSection6sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    chooseSection6sH3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseSection6sItem) => Partial<ComponentProps<"h3">>);
};

const HomeFourteenChooseSectionGenerated: FC<HomeFourteenChooseSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0H20H2Text = "Ready Discover More? Contact Us Today!",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0ImageWithBasePath0ImageAlt = "bg",
    sectionDiv0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/offer-bg.png",
    sectionDiv0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div1Div0Div0H20H2Text = "Why",
    sectionDiv0Div1Div0Div0H20H2Visible,
    sectionDiv0Div1Div0Div0H20H2Renderer,
    sectionDiv0Div1Div0Div0H20H2Props,
    sectionDiv0Div1Div0Div0H20Span0SpanText = "Choose",
    sectionDiv0Div1Div0Div0H20Span1SpanText = "Our Clinic",
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    sectionDiv0Div0Div0ClassName,
    sectionDiv0Div1ClassName,
    sectionDiv0Div1Div1Div0ClassName,
    chooseSectionOfferInfos,
    chooseSection6s,
    chooseSectionOfferInfosItemWrapper,
    chooseSectionOfferInfosRenderer,
    chooseSection6sItemWrapper,
    chooseSection6sRenderer,
    chooseSection6sImageVisible,
    chooseSection6sImageRenderer,
    chooseSection6sH3Visible,
    chooseSection6sH3Renderer,
    chooseSection6sImageProps,
    chooseSection6sH3Props,
}) => {
    return (
        <section className="offer-section-fourteen section">
            <div className="container">
                <div className="offer-sec">
                    <div className={sectionDiv0Div0Div0ClassName ?? "row g-4 align-items-center"}>
                        <div className="col-lg-5 col-xl-6">
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0H20H2Text}</h2>
                            ))}
                        </div>
                        <div className="col-lg-7 col-xl-6">
                            <div className="offer-wrap">
                                {renderCollectionNode(
                                    chooseSectionOfferInfos,
                                    (item: ChooseSectionOfferInfosItem) => (
                                        <div className={item.divClassName ?? "offer-info"} key={item.key}>
                                            <div className={item.div0ClassName ?? "offer-icon"}>
                                                <i className={item.className} />
                                            </div>
                                            <div>
                                                <p className={item.p0ClassName ?? "title"}>{item.p0Text}</p>
                                                <p className={item.p1ClassName ?? "fw-semibold mb-0"}>{item.p1Text}</p>
                                            </div>
                                        </div>
                                    ),
                                    chooseSectionOfferInfosItemWrapper,
                                    chooseSectionOfferInfosRenderer
                                )}
                            </div>
                        </div>
                    </div>
                    {renderNode(sectionDiv0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={sectionDiv0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0ImageWithBasePath0ImageAlt} className="offer-bg img-fluid" {...(sectionDiv0Div0ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row"}>
                    <div className="col-xl-5">
                        <div className="section-header section-header-fourteen wow fadeInUp" data-wow-duration={sectionDiv0Div1Div0Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div1Div0Div0H20H2Visible, sectionDiv0Div1Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div1Div0Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div1Div0Div0H20H2Text}
                                    <span className="section-line">{sectionDiv0Div1Div0Div0H20Span0SpanText}</span>
                                    {" "}
                                    <span className="subtitle">{sectionDiv0Div1Div0Div0H20Span1SpanText}</span>
                                </h2>
                            ))}
                        </div>
                    </div>
                    <div className="col-xl-7">
                        <div className={sectionDiv0Div1Div1Div0ClassName ?? "row g-4"}>
                            {renderCollectionNode(
                                chooseSection6s,
                                (item: ChooseSection6sItem) => (
                                    <div className={item.divClassName ?? "col-md-6 d-flex"} key={item.key}>
                                        <div className={item.className}>
                                            <div className={item.div0ClassName ?? "offer-icon"}>
                                                {renderItemNode(chooseSection6sImageVisible, chooseSection6sImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof chooseSection6sImageProps === "function" ? chooseSection6sImageProps(item) : (chooseSection6sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </div>
                                            {renderItemNode(chooseSection6sH3Visible, chooseSection6sH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title mb-2"} {...(typeof chooseSection6sH3Props === "function" ? chooseSection6sH3Props(item) : (chooseSection6sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                            ))}
                                            <p className={item.p0ClassName ?? "mb-0"}>{item.p0Text}</p>
                                        </div>
                                    </div>
                                ),
                                chooseSection6sItemWrapper,
                                chooseSection6sRenderer
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeFourteenChooseSectionGenerated;
